import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';

const Placeholder = ({ icon, title, subtitle, ...props }) => {
	return (
		<Box
			p={2}
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			height="100%"
			width="100%"
		>
			{icon && <Avatar>{icon}</Avatar>}
			<Typography variant="h5">{title}</Typography>
			<Typography variant="body2">{subtitle}</Typography>
		</Box>
	);
};

export default Placeholder;
